import { TabSubject } from "./tab-subjects";

export * from "./actions";
export * from "./tab-subjects";

export interface WithTabSubject<T extends TabSubject> {
  readonly tabSubject: T;
}
